export class Watermark {
  static defaultOption = {
    id: 'watermark',
    container: document.body,
    content: 'watermark',
    zIndex: 999999,
    width: 300,
    height: 200,
    font: '400 12px sans-serif',
    textAlign: 'center',
    textBaseline: 'middle',
    color: 'rgba(128, 128, 128, 0.15)',
    rotate: -34,
  };

  constructor(option = {}) {
    this.option = Object.assign({}, Watermark.defaultOption, option);
    const watermark = this._createWatermark();
    this.watermark = watermark;
    this.option.container.appendChild(watermark);
  }

  _createWatermark() {
    const { id, zIndex } = this.option;
    const dataUrl = this._getDateUrl();
    const watermark = document.createElement('div');
    watermark.id = id;
    watermark.style.cssText = `
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      position: fixed;
      top: 0;
      left: 0;
      z-index: ${zIndex};
      background: url(${dataUrl}) left top repeat;
    `;
    this.option.container.appendChild(watermark);
    return watermark;
  }

  _createCanvas() {
    const { width, height, font, textAlign, textBaseline, color, rotate, content } = this.option;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.font = font;
    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.fillStyle = color;
    ctx.translate(parseFloat(width) / 2, parseFloat(height) / 2);
    ctx.rotate((Math.PI / 180) * rotate);
    ctx.fillText(content, 0, 0);
    return canvas;
  }

  _getDateUrl() {
    let canvas = this._createCanvas();
    const dataUrl = canvas.toDataURL('image/png');
    canvas = null;
    return dataUrl;
  }

  /**
   * 监听 dom 变化
   */
  observe(handler) {
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    if (MutationObserver) {
      const ob = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.target === this.watermark) {
            handler(m);
            break;
          } else if (m.type === 'childList' && m.removedNodes.length > 0) {
            for (let i = 0; i < m.removedNodes.length; i++) {
              if (m.removedNodes[i] === this.watermark) {
                handler(m);
                break;
              }
            }
          }
        }
      });
      ob.observe(this.option.container, { attributes: false, childList: true, subtree: false, characterData: false });
      ob.observe(this.watermark, { attributes: true, childList: false, subtree: false, characterData: false });
    } else {
      console.error('MutationObserver not support');
    }
  }
}
